<script>
    import { onMount, onDestroy } from 'svelte';
    import { page, modal } from '../store/nav';
    import { productsIDB } from '../store/products';
    import { recentIDB } from "../store/recent";
    import { items } from '../store/items';
    import { recurring } from "../store/recurring";
    import { categories } from "../store/categories";
    import { createId, nextDate} from "../js/helper";

    export let list_uid;
    export let category_uid = 'misc';
    export let name = '';
    export let redirect;

    const newProduct = {
      uid: createId.md(),
      name: name,
      category: category_uid
    };

    const createNewProduct = () => {
      productsIDB.add(newProduct);

      if ( list_uid == "recurring" ){
        const newItem = {
          "uid":createId.uuid(),
          "name":newProduct.name,
          "productUid":`${newProduct.uid}`,
          "category":category_uid,
          "qty":1,
          "unit":"bunch",
          "storeUid":"",
          "frequency":"",
          "qty":1,
          "unit":"",
          "next":nextDate(7),
          "options":$categories[category_uid].options,
          "cut":"",
          "details":""
        };

        recurring.add(newItem);

        modal.close();
        if ( !! redirect && redirect != "undefined"  ) {
          page.route(`${redirect}?list_uid=${list_uid}&item_uid=${newItem.uid}`)
        } else {
          page.route('/lists/recurring');
        }
      } else {
        const newItem = {
          "uid":createId.uuid(),
          "productUid":`${newProduct.uid}`,
          "listUid":list_uid,
          "name":newProduct.name,
          "category":category_uid,
          "collected":false,
          "status":"it_none",
          "qty":1,
          "unit":"",
          "cut":"",
          "recurring": false,
          "next":nextDate(7),
          "options":$categories[category_uid].options,
          "details":""
        };

        items.add(newItem);
        recentIDB.add( `items_${category_uid}`, {uid:newItem.uid,name:newItem.name,category: category_uid},  {relatedStore: `items_all`} );

        modal.close();

        if ( !! redirect && redirect != "undefined"  ) {
          page.route(`${redirect}?list_uid=${list_uid}`)
        } else {
          page.route('/lists/items?list_uid='+list_uid);
        }
      }
    };
</script>
<section class="flex flex-col space-y-7">
  <section class="mt-5 form-input-text relative h-16 text-primary">
    <span class="absolute inset-y-0 left-0 h-16 z-10 flex items-center px-2 ">
      {#if category_uid}
        <div class="bg-primary rounded-2xl w-12 h-12"><img class="m-auto w-8 mt-2" src="/img/icon/food/{category_uid}.png" alt=""  on:click|stopPropagation={() => modal.open(`/select-category?list_uid=${list_uid}&name=${name}&anchor=bottom`)}></div>
      {:else}
      <div class="bg-primary rounded-2xl w-12 h-12"><img class="m-auto w-8 mt-2" src="/img/icon/food/misc.png" alt=""  on:click|stopPropagation={() => modal.open(`/select-category?list_uid=${list_uid}&name=${name}&anchor=bottom`)}></div>
      {/if}
      
    </span>
    <input type="text" style="width: 100%;" bind:value={newProduct.name} class="z-0 h-16 pl-20 text-2xl placeholder-primary rounded-3xl focus:caret-agrume focus:border-agrume focus:ring-1 focus:ring-agrume focus:outline-none focus:placeholder-white" placeholder="Item name" autocomplete="off" >
  </section>
  <div class="bg-secondary h-16 rounded-3xl text-center text-primary flex items-center justify-center" on:click={createNewProduct}>Create new Item</div>
</section>